export default "__VITE_ASSET__1ab996d6__"